import { Box, Container, Flex, Text } from '@chakra-ui/react';
import React from 'react';

const GreenReturnSummitSpeakers = () => (
  <Container maxW="container.lg">
    <Box padding={{ xs: '50px 0px', md: '100px 50px 56px' }} mt="10px">
      <Flex flexDirection="column">
        <Text
          fontWeight="700"
          fontSize={{ xs: '26px', md: '36px' }}
          lineHeight="130%"
          color="#197542"
          textAlign="left"
          mb="2rem"
          borderLeft="3px solid #197542"
          pl="10px"
        >
          IVCA GreenReturns Summit Secretariat
        </Text>
        <Text
          fontWeight="400"
          fontSize={{ xs: '14px', md: '18px' }}
          lineHeight="150%"
          mb="1rem"
          letterSpacing="0.02em"
          color="#46564A"
        >
          We are pleased to announce that the Summit is being chaired by Shri
          Jayant Sinha, former Minister of State for Finance and former Minister
          of State for Civil Aviation, Government of India. Our Climate &
          Sustainability Council co-chairs, Pratibha Jain, Head of Strategy at
          Eversource Capital and Akhilesh Tilotia, Distinguished Fellow at
          Infravision Foundation, along with the IVCA team will be leading the
          execution of the event.
        </Text>
        {/* <Text
          fontWeight="400"
          fontSize={{ xs: '14px', md: '18px' }}
          lineHeight="150%"
          mb="1rem"
          letterSpacing="0.02em"
          color="#46564A"
        >
          IVCA GreenReturns Summit aims to serve as a crucial crucible for
          facilitating dialogues and interactions for climate finance to find
          the appropriate investments. The Summit will provide an excellent
          forum for conducting multiple side meetings with diverse investors and
          policymakers, further enhancing collaborative opportunities and
          strategic partnerships.
          <br />
          <br />
          The initiative is poised to become a major annual event, attracting
          hundreds of delegates, including global North investors, domestic and
          international PE/VC/credit/infra funds, portfolio companies,
          policymakers, academics, and other key stakeholders from the climate
          finance community.
        </Text> */}
      </Flex>
    </Box>
  </Container>
);

export default GreenReturnSummitSpeakers;
